import { Button } from 'system/atoms';
import { useNavigate } from 'react-router-dom';

type Props = {
  campaignId?: string | null;
};

export const CampaignCreationCancelButton: React.FC<Props> = ({
  campaignId
}) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(-1);
  };

  // Don't render if campaignId exists (draft already created)
  if (campaignId) {
    return null;
  }

  return (
    <Button variant="tertiary" onClick={handleCancel}>
      Cancel
    </Button>
  );
};
